<template>
	<div class='knd-quiz' :class="{'answered': showAnswer}">
		<div class='quiz-container m-t-md'>
			<div>
				<h2>{{question.titel}}</h2>
			</div>

				<div class='quiz-item-label'>
					<span>{{question.opties[0].naam}}</span> of 
					<span>{{question.opties[1].naam}}</span>
				</div>

			<div class='knd-options m-t-lg m-b-md'>
					<div 
						:key="'optie' + index"
						class='knd-quiz__option' 
						:class='{selected : selectedOption === index, "wrong-answer" : wrongAnswer(index)}'
						v-on:click="selectOption(index)"
						v-for="(option, index) in question.opties" >
							<div class='knd-option__image'>

								<img 
									class='quiz__option_afbeelding'
									v-if="option.afbeelding"
									:src='"https://pointer-dev.kro-ncrv.nl/" + option.afbeelding[0].mobile_url' 
								/>

								<img 
									class='quiz__option_afbeelding_wrong'
									v-if="wrongAnswer(index)"
									src='@/assets/kruis.svg'
								/>

							</div>
							
							<div 
								v-if='showAnswer' 
								class='suikerklontjes-container'>
								<div class='suikerklontje' 
									v-if="Math.floor(option.suikerklontjes) % 2 !== 0 && !hasHalf(option.suikerklontjes) || Math.floor(option.suikerklontjes) % 2 === 0 && hasHalf(option.suikerklontjes) ">
										<img src='@/assets/klontje.png' class='hide' />
								</div>
								<div class='suikerklontje' 
									v-if="hasHalf(option.suikerklontjes)">
									<img src='@/assets/half-klontje.png' />
								</div>
								<div class='suikerklontje' 
									:key='"suikerklontjes" + index'
									v-for="(item, index) in Math.floor(option.suikerklontjes)">
									<img src='@/assets/klontje.png' />
								</div>
							</div>
					</div>
			</div>
			
			<div v-if='showAnswer'>
				<h3>{{question.opties[selectedOption].naam}} is {{correctAnswer ? 'goed!' : 'fout!' }}</h3>
				<div v-html="question.feedback"></div>
			</div>

			<div v-if='showAnswer'>
				<div class='m-t-lg m-b-lg'>
					<div class='knd-btn knd-btn-default' v-on:click="next">
						volgende
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

	import './index.scss';

export default {

	name: 'quiz',
	props: ['question'],

	data () {
		return {
			showAnswer: false,
			correctAnswer: '',
			res: [],
			selectedOption: undefined
		}
	},
	methods: {
		selectOption (index) {
			const max = Math.max(...this.question.opties.map((i) => Number(i.suikerklontjes)));
			this.res = [];
			this.question.opties.forEach((item, index) => 
				Number(item.suikerklontjes) === max ? this.res.push(index): null
			);

			this.selectedOption = index;
			this.correctAnswer = this.res.length > 1 ? true : index === this.res[0];

			this.showAnswer = true;

			this.$nextTick(function () {
				this.$store.dispatch('correctAnswer', this.correctAnswer);
			})

		},

		wrongAnswer(index) {
			return this.showAnswer && !this.res.includes(index);
		},

		hasHalf(num) {
			return Number(num) % 1;
		},

		next() {
			this.$store.dispatch('next');

			// this.reset();
		},

		reset() {
			this.correctAnswer = '';
			this.showAnswer = false;
			this.selectedOption = undefined;
			this.res = [];
		}
	}
}
</script>

<style lang="css" scoped>
</style>